import api from "../api";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { partyState } from "../Recoil/atom";
import { useRecoilState } from "recoil";

const Poke_party = () => {
  const navigate = useNavigate();
  const [party, setParty] = useState([]);
  const [partyAtom, setPartyAtom] = useRecoilState(partyState);
  useEffect(() => {
    async function fetchData() {
      try {
        const response = await api.get("/v1/roster", {
          withCredentials: true,
        });
        setPartyAtom(response.data);
      } catch (error) {
        navigate("/login");
      }
    }

    fetchData();
  }, []);

  // Return the data in the format you specified.
  return party.map((poke) => ({
    name: poke.name,
    level: poke.totalexp,
    move1: poke.move1,
    move2: poke.move2,
    move3: poke.move3,
    move4: poke.move4,
  }));
};

export default Poke_party;
